export const siteSettings = {
  name: "Priority Market Exchange",
  link: "https://prioritymarketexchange.org",
  email: "support@prioritymarketexchange.org",
  appLink: "https://app.prioritymarketexchange.org",
};
